import * as React from 'react'

interface IconProps extends React.SVGProps<SVGSVGElement> {}

const LMX: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={24}
    height={24}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    {...props}
  >
    <g
      style={{
        stroke: "none",
        strokeWidth: 0,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "currentColor",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
    >
      <path
        d="M 17.884 19.496 L 38.925 47.63 L 17.751 70.504 h 4.765 l 18.538 -20.027 l 14.978 20.027 h 16.217 L 50.024 40.788 l 19.708 -21.291 h -4.765 L 47.895 37.94 L 34.101 19.496 H 17.884 z M 24.892 23.006 h 7.45 L 65.24 66.993 h -7.45 L 24.892 23.006 z"
        style={{
          stroke: "currentColor",
          strokeWidth: 2,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "currentColor",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform=" matrix(1 0 0 1 0 0) "
        strokeLinecap="round"
      />
      <path
        d="M 71.01 90 H 18.99 C 8.519 90 0 81.481 0 71.01 V 18.99 C 0 8.519 8.519 0 18.99 0 h 52.02 C 81.481 0 90 8.519 90 18.99 v 52.02 C 90 81.481 81.481 90 71.01 90 z M 18.99 3 C 10.173 3 3 10.173 3 18.99 v 52.02 C 3 79.827 10.173 87 18.99 87 h 52.02 C 79.827 87 87 79.827 87 71.01 V 18.99 C 87 10.173 79.827 3 71.01 3 H 18.99 z"
        style={{
          stroke: "currentColor",
          strokeWidth: 2,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "currentColor",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform=" matrix(1 0 0 1 0 0) "
        strokeLinecap="round"
      />
    </g>
  </svg>
)

export default LMX
